import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class MenuOpened {
	sidenavOpened = false
}
